import React, { useState, useRef } from 'react'
import { Button, Collapse } from 'antd'
import { DisplayDate } from '../../../../components/_utils/appUtils'
import { RowTable } from '../../../../containers/article/articleView/RowTable'
// import ReceiveDateDrawer from '../abstractPages/SelectReceiveDateDrawer'
import EditAbsrtactReceiveDate from '../abstractPages/EditAbstractReceiveDate'

const { Panel } = Collapse

const ReviewedAbstracts = (props) => {
  const [reviewerId, setReviewerId] = useState('');
  let { abstract } = props
  // Mapping 'selectedReviewer' to your view logic
  let reviewerData = abstract.selectedReviewer && abstract.selectedReviewer.length > 0
    ? abstract.selectedReviewer[0]
    : null

  let [isDrawerVisible, setIsDrawerVisible] = useState(false)

  // Header logic matching your article pattern
  let headerTitle = `Reviewed Abstract ${reviewerData && reviewerData.receiveDate ? `(${DisplayDate(reviewerData.receiveDate)})` : ''}`

  let getExtraButton = () => {
    const id = (reviewerData.reviewerId && reviewerData.reviewerId._id)
      ? reviewerData.reviewerId._id
      : reviewerData.reviewerId;
    return (
      <React.Fragment>
        {reviewerData && reviewerData.receiveDate ? (
          <Button
            type={'primary'}
            size={'small'}
            onClick={(event) => {
              // setIsDrawerVisible(true)
              // event.stopPropagation()
              setReviewerId(id);
              setIsDrawerVisible(true);
              event.stopPropagation();
            }}
          >
            Edit
          </Button>
        ) : null}
      </React.Fragment>
    )
  }
  return (
    <div>
      <Collapse expandIconPosition={'right'} defaultActiveKey={['1']}>
        <Panel header={headerTitle} key="1" extra={getExtraButton()}>
          <div className={'tableBox striped'}>
            <RowTable title={'Comments Attachment'} value={
              reviewerData && reviewerData.abstractcommentsAttachment && reviewerData.abstractcommentsAttachment.path ?
                <a download className='downloadLink' target={'_blank'} rel="noreferrer"
                   href={reviewerData.abstractcommentsAttachment.path}>Download</a> : 'No Attachment'
            } />
            <RowTable title={'Abstract Attachment'} value={
              reviewerData && reviewerData.abstractAttachment && reviewerData.abstractAttachment.path ?
                <a download className='downloadLink' target={'_blank'} rel="noreferrer"
                   href={reviewerData.abstractAttachment.path}>Download</a> : 'No Attachment'
            } />
            <RowTable title={'See Abstract Again'} value={
              reviewerData ?
                <p>{reviewerData.abstractSeeAgain ? 'True' : 'False'}</p> : null
            } />
          </div>
        </Panel>
      </Collapse>
      {isDrawerVisible && reviewerData ? (
        <EditAbsrtactReceiveDate
          visible={isDrawerVisible}
          abstract={abstract}
          reviewerId={reviewerId}
          onClose={() => setIsDrawerVisible(false)}
        />
      ) : null}
      {/*{receiveDateDrawerVisible ? (*/}
      {/*  <ReceiveDateDrawer*/}
      {/*    visible={receiveDateDrawerVisible}*/}
      {/*    abstract={abstract}*/}
      {/*    reviewerId={reviewerData ? reviewerData.reviewerId : null}*/}
      {/*    onClose={() => setReceiveDateDrawerVisible(false)}*/}
      {/*  />*/}
      {/*) : null}*/}
    </div>
  )
}

export default ReviewedAbstracts
